import React from 'react';
import TrendingIcons from './TrendingIcons';
import TrendingTopics from './TrendingTopics';

export default function FeedSidebar() {
  return (
    <div className="sticky top-24 space-y-6">
      <TrendingIcons />
      <TrendingTopics />
    </div>
  );
}